<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import Swal from "sweetalert2";
import CopasstActAPI from "@/services/standards/copasst/copasstActAPI";
import MeetingAPI from "@/services/standards/copasst/meeting/meetingAPI";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Acta de Seguimiento",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "Acta de Seguimiento Copasst",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "1.1.6 Acta de conformación Copasst Vigía de salud",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id}/acta-conformacion1.1.6`,
        },
        {
          text: "Listado de seguimiento Copasst",
          href: `/forms/estandares/${this.$route.params.id}/seguimiento-copasst`,
        },
        {
          text: "Registro de Acta de seguimiento Copasst",
          active: true,
        },
      ],

      showNotification: false,
      message: null,
      copasstID: this.$route.params.id,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      company: null,
      meeting: {
        copasst_act: "Acta de reunión comité de Copasst",
        copasst_date: null,
        copasst_place: null,
        copasst_start_hour: null,
        copasst_end_hour: null,
        copasst_agenda: null,
        copasst_meeting: null,
        copasst_act_id: null,
        certificate: "file",
      },
      members: [],
      loading: true,
      itemData: null,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(6)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This methods allows print the act
     */
    print(id) {
      const word = MeetingAPI.getWord(id);
      window.location.href = word;
    },

    /**
     * This method allows change the status of the showNotification variable.
     */
    setShowNotification() {
      this.showNotification = !this.showNotification;
    },

    /**
     * This method allows save the meeting.
     */
    save() {
      let assistants = this.members.filter((member) => member.assistence);
      this.meeting.copasst_act_id = this.copasstID;
      MeetingAPI.save(this.meeting)
        .then((response) => {
          if (response.Success) {
            const id = response.id;
            let promises = [];
            assistants.forEach((assistant) => {
              promises.push(MeetingAPI.saveMember(id, assistant.employee_id));
            });
            Promise.all(promises)
              .then((response) => {
                const itemChange = {
                  companies_id: this.companyID,
                  item_id: 6,
                  status: 'Pendiente',
                };
                newScoresAPI.calculateScores(itemChange)
                  .then((response) => {
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Se ha registrado con éxito!",
                      type: "success",
                      icon: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.href = `/forms/estandares/${this.copasstID}/seguimiento-copasst`;
                  })
                  .catch((error) => {
                    this.loading = false
                    setTimeout(() => {
                      Swal.fire({
                        title: "Error",
                        text: "¡No se ha podido registrar!",
                        icon: "error",
                        type: "error",
                        confirmButtonClass: "btn btn-confirm mt-2",
                      });
                      window.location.reload();
                    }, 1000);
                    console.log(error);
                  });
              })
              .catch((error) => {
                Swal.fire({
                  title: "¡Error!",
                  text: "¡No se ha podido registrar!",
                  type: "error",
                  icon: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
              });
          } else {
            Swal.fire({
              title: "¡Alerta!",
              text: "¡Hubo problemas guardando el acta!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "¡Error!",
            text: "¡Hubo problemas guardando el acta!",
            type: "error",
            icon: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        });
    },

    /**
     * This method is used to know if the Copasst Act exists.
     * If exists, it will get the data.
     * If not, it will create a new Copasst Act.
     */
    getCopasst() {
      if (this.copasstID !== 0) {
        CopasstActAPI.getActById(this.copasstID)
          .then((response) => {
            const copasst = response[0] || null;
            this.exist = true;
            if (copasst) {
              this.copasstAct = copasst;
              this.members = copasst.copasst_candidates;

              this.members.forEach((member) => {
                member.is_distinguished === 1
                  ? (member.is_distinguished = true)
                  : (member.is_distinguished = false);
                member.president === 1
                  ? (member.president = true)
                  : (member.president = false);
                member.secretary === 1
                  ? (member.secretary = true)
                  : (member.secretary = false);
                member.assistence = true;
              });

              this.members = this.members.sort((a, b) => {
                if (a.is_distinguished) {
                  return -1;
                } else if (b.is_distinguished) {
                  return 1;
                } else {
                  return 0;
                }
              });

              this.members = this.members.sort((a, b) => {
                if (a.secretary) {
                  return -1;
                } else if (b.secretary) {
                  return 1;
                } else {
                  return 0;
                }
              });

              this.members = this.members.sort((a, b) => {
                if (a.president) {
                  return -1;
                } else if (b.president) {
                  return 1;
                } else {
                  return 0;
                }
              });

              let membersNoRepeat = [];

              this.members.forEach((member) => {
                if (
                  !membersNoRepeat.find(
                    (memberNoRepeat) => memberNoRepeat.employee_id === member.employee_id
                  )
                ) {
                  membersNoRepeat.push(member);
                }
              });

              this.members = membersNoRepeat;

              this.loading = false;
            } else {
              this.exist = false;
              this.loading = false;
            }
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      }
    },

    /**
     * This method is used to go back to the previous page.
     */
    goBack() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.getCopasst();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div v-if="!loading">
          <div class="card">
            <div class="card-body">
              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-6 px-2" label="Fecha" label-for="meetingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="meetingDate"
                      placeholder="Fecha de la reunión" v-model="meeting.copasst_date"></b-form-input>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Lugar" label-for="place">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="text" id="place"
                      placeholder="Lugar de la reunión" v-model="meeting.copasst_place"></b-form-input>
                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Hora inicio" label-for="startHour">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="time" id="startHour"
                      v-model="meeting.copasst_start_hour"></b-form-input>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Hora finalización" label-for="endHour">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="time" id="endHour"
                      v-model="meeting.copasst_end_hour"></b-form-input>
                  </b-form-group>
                </div>

                <div>
                  <h4>Asistentes</h4>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <table
                      class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-md-12">
                      <thead class="table-active">
                        <tr class="col-sm-12">
                          <th scope="col" class="text-left text-xs font-medium text-gray-500 align-middle col-sm-8">
                            Nombre
                          </th>
                          <th scope="col" class="text-left text-xs font-medium text-gray-500 align-middle col-sm-6">
                            Cargo
                          </th>
                          <th scope="col" class="text-left text-xs font-medium text-gray-500 align-middle col-sm-4">
                            Asistencia
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-for="member in members" :key="member.id">
                          <td class="text-left">
                            <div class="col-sm-12 form-control input mx-1">
                              {{ member.employee.full_name }}
                            </div>
                          </td>
                          <td class="text-left">
                            <div class="col-sm-12 form-control input mx-1">
                              {{
                                member.president
                                  ? "Presidente"
                                  : member.secretary
                                    ? "Secretario"
                                    : "N/A"
                              }}
                            </div>
                          </td>
                          <td class="text-center col-sm-12">
                            <b-form-checkbox :disabled="!allowAccess() || !getRole('Crear')" v-model="member.assistence"
                              name="check-button" switch>
                            </b-form-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-12 px-2" label="Orden del día" label-for="agenda">
                    <textarea :disabled="!allowAccess() || !getRole('Crear')" id="agenda" class="form-control" rows="5"
                      v-model="meeting.copasst_agenda"></textarea>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Desarrollo de la reunión" label-for="meeting">
                    <textarea :disabled="!allowAccess() || !getRole('Crear')" id="meeting" class="form-control" rows="5"
                      v-model="meeting.copasst_meeting"></textarea>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button type="submit" :disabled="!allowAccess() || !getRole('Crear')" class="btn btn-primary">Guardar</button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
